<template>
  <div class="bg-black min-h-screen">
    <skeleton-movie-details v-if="isLoading.single" />
    <div class="relative" v-else>
      <div
        class="banner"
        :style="{
          backgroundImage: `url(${backdropUrl(data['backdrop_path'])})`
        }"
      />

      <div class="absolute w-full text-gray-300 content-details">
        <div class="text-center mb-8 -mt-8">
          <h1 class="text-4xl lead-normal text-white">{{ data["title"] }}</h1>
          <p class="text-lg font-semibold leading-relaxed mt-4 mb-2 uppercase">
            {{ data["tagline"] }}
          </p>
          <div class="flex items-center justify-center flex-wrap">
            <span class="mr-1 text-yellow-500">
              <i class="fas fa-star mr-1"></i>
              {{ data["vote_average"] * 10 + "%" }}</span
            >
            |
            <ul class="ml-1 inline-flex justify-between" v-if="data.genres">
              <li
                class="mr-1"
                v-for="genre in genres(data.genres)"
                :key="genre"
              >
                {{ genre }}
              </li>
            </ul>
          </div>
        </div>
        <div class="relative w-11/12 mx-auto bg-gray-900 p-3 py-6 z-2 mb-16">
          <keep-alive>
            <component :is="component" :data="data" />
          </keep-alive>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watch, markRaw, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Movie from "./Movie";
import Casts from "./Casts";
import SkeletonMovieDetails from "@/components/Skeleton/MovieDetails/SkeletonMovieDetails.vue";
export default {
  components: {
    SkeletonMovieDetails
  },
  name: "movie-details",
  setup() {
    const store = useStore();
    const route = useRoute();
    let component = ref();

    const DynamicComponent = () => {
      route.matched.map(match => {
        if (match.path === "/movies/:id/casts") {
          component.value = markRaw(Casts);
        }
        if (match.path === "/movies/:id") {
          component.value = markRaw(Movie);
        }
      });
    };

    let data = computed(() => store.state["tmdbApi"].singleDetails);
    let isLoading = computed(() => store.state["tmdbApi"].isLoading);

    onMounted(() => {
      store.dispatch("tmdbApi/fetchSingleMovie", route.params.id);

      DynamicComponent();
    });

    watch(
      () => route.path,
      () => {
        DynamicComponent();
      }
    );
    watch(
      () => route.params.id,
      async id => {
        await store.dispatch("tmdbApi/fetchSingleMovie", id);
      }
    );

    const genres = data =>
      data.map((item, index) => {
        if (index === data.length - 1) {
          return item.name;
        }
        return item.name + ", ";
      });

    return {
      data,
      isLoading,
      genres,
      component
    };
  }
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  background-position: center 0;
  background-size: cover;
  transition: opacity 0.25s ease 0s;
  height: 600px;
  opacity: 0.3;
}
.content-details {
  top: 200px;
}

@media screen and (min-width: 600px) {
  .content-details {
    top: 300px;
  }
}
</style>
